import React from 'react';
import { Link } from 'react-router-dom';
import PublicSEO from '../../components/public/PublicSEO';
import { Heading, PageContainer } from '../../components/ui';
import { publicPath } from '../../utils/canonicalUrl';
import { buildBreadcrumb } from '../../utils/jsonLd';
import './ContentGuide.css';
import './PerLeStrutturePage.css';

const VANTAGGI = [
  {
    title: 'Hub e agende',
    body: 'Isolamento per struttura, medici collegati e widget Prenota da inserire sul vostro sito.',
  },
  {
    title: 'Pratiche fondi',
    body: 'Stati PIC e documenti richiesti tracciati in un unico elenco operativo.',
  },
  {
    title: 'Report Insight',
    body: 'Sintesi mensile su prenotazioni e segnali operativi, senza usare dati clinici per il marketing.',
  },
  {
    title: 'API FHIR',
    body: 'Sandbox Schedule / Slot / Appointment con chiave API e webhook firmati HMAC.',
  },
];

const FAQ_B2B = [
  {
    q: 'Sostituisce il nostro gestionale?',
    a: 'No: Virtual Clinic affianca il gestionale con agende pubbliche, prenotazioni e integrazioni FHIR.',
  },
  {
    q: 'Come si richiede una demo?',
    a: 'Usate il modulo contatti indicando «struttura» nel messaggio: vi rispondiamo con i passi di onboarding.',
  },
  {
    q: 'Dove trovo la documentazione API?',
    a: 'La documentazione interattiva è su /scalar; il dettaglio tecnico è nella pagina Integrazioni.',
  },
];

export default function PerLeStrutturePage() {
  return (
    <div className="vc-b2b">
      <PublicSEO
        title="Per le strutture sanitarie"
        description="Hub struttura Virtual Clinic: agende, widget Prenota, pratiche fondi, report operativi e API FHIR per i gestionali."
        canonicalPath="/per-le-strutture"
        jsonLd={[
          buildBreadcrumb([
            { name: 'Home', path: '/' },
            { name: 'Per le strutture' },
          ]),
        ]}
      />

      <section className="vc-b2b-hero">
        <PageContainer narrow className="vc-b2b-hero__inner">
          <Heading level={1}>Pubblicate le disponibilità. Raccogliete le prenotazioni.</Heading>
          <p className="vc-b2b-hero__lead">
            Un hub per agende, widget Prenota, pratiche fondo e collegamento al gestionale —
            senza sostituire il vostro software clinico.
          </p>
          <div className="vc-b2b-hero__cta">
            <Link to={publicPath('/contatti')} className="vc-btn vc-btn-primary">
              Richiedi una demo
            </Link>
            <Link to="/login" className="vc-btn vc-btn-outline">
              Accedi all&apos;hub
            </Link>
          </div>
        </PageContainer>
      </section>

      <section className="vc-b2b-section">
        <PageContainer>
          <Heading level={2}>Cosa include</Heading>
          <ul className="vc-b2b-vantaggi">
            {VANTAGGI.map((v) => (
              <li key={v.title}>
                <h3>{v.title}</h3>
                <p>{v.body}</p>
              </li>
            ))}
          </ul>
        </PageContainer>
      </section>

      <section className="vc-b2b-section vc-b2b-section--muted">
        <PageContainer narrow>
          <Heading level={2}>Documentazione per chi integra</Heading>
          <p>
            Documentazione interattiva su <a href="/scalar">/scalar</a>.
            Dettaglio tecnico: <Link to={publicPath('/integrazioni')}>Integrazioni</Link>.
          </p>
        </PageContainer>
      </section>

      <section className="vc-b2b-section">
        <PageContainer narrow>
          <Heading level={2}>Domande frequenti</Heading>
          <div className="vc-b2b-faq">
            {FAQ_B2B.map((item) => (
              <details key={item.q}>
                <summary>{item.q}</summary>
                <p>{item.a}</p>
              </details>
            ))}
          </div>
          <div className="vc-b2b-hero__cta" style={{ marginTop: '1.5rem' }}>
            <Link to={publicPath('/contatti')} className="vc-btn vc-btn-primary">
              Contatti
            </Link>
          </div>
        </PageContainer>
      </section>
    </div>
  );
}
